import Auth from "@aws-amplify/auth"
import { useEffect } from "react"
import { navigate } from "gatsby"
import { connect } from "react-redux"
import { verifyUser } from "../../../state/actions/user"
import { trackAmplitudeIdentity } from "../../../helpers/amplitude"
import { trackSegmentEvent } from "../../../helpers/segment"

// setup all amplify modules for all private routes
import Amplify from "@aws-amplify/core"
import API from "@aws-amplify/api" // eslint-disable-line
import awsconfig from "../../../aws-exports"
import { trackFBIdentity } from "../../../helpers/fbPixel"
Amplify.configure(awsconfig)

const RedirectRoute = ({ children, isLoggedIn, to, verifyUser }) => {
  useEffect(() => {
    if (isLoggedIn) return
    verifyUser(Auth)
      .then(user => {
        if (!user) throw new Error("missing user")
        return user
      })
      .then(user => {
        const { email, sub } = user.attributes
        trackSegmentEvent("identify", sub, { email })
        trackAmplitudeIdentity(sub, email)
        trackFBIdentity(email)
      })
      .catch(e => {
        console.log(e)
        // do nothing
      })
  }, []) // eslint-disable-line

  if (isLoggedIn) {
    navigate(to, { replace: true })
    return null
  }

  return children
}

export default connect(
  ({ user }) => ({ isLoggedIn: user.isLoggedIn }),
  { verifyUser }
)(RedirectRoute)
